import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Container, Image } from "react-bootstrap";
import "./index.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import { getApi, postBankInfo } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import Spinner from "../../../common/Spinner";

const BankingAndTaxation = () => {
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState("");
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const { requestCall, bankInfo } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    getApi("getBankInfo", dispatch);
  }, [dispatch]);

  useEffect(() => {
    setIsUpdateMode(false);
    if (bankInfo?.data === null) {
      setIsCreateMode(true);
    } else {
      setIsCreateMode(false);
    }
  }, [bankInfo]);

  const onSelectValue = (key, value) => {
    // console.log("*** change ", key, value)
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousVlaues) => ({
      ...previousVlaues,
      ...updatedObj,
    }));
  };

  const createUpdateBankingInfo = (e) => {
    e.preventDefault();
    setErrorMsg(null);

    let fileErrors = [];
    if (!uploadFormObj?.cancelled_cheque) {
      fileErrors.push("Please upload a cancelled cheque.");
    }

    if (fileErrors.length > 0) {
      setErrorMsg(fileErrors);
      return;
    }

    if (
      !isEmpty(uploadFormObj) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "account_name") &&
      !isEmpty(uploadFormObj.account_name) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "account_number") &&
      !isEmpty(uploadFormObj.account_number) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "bank_name") &&
      !isEmpty(uploadFormObj.bank_name) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "ifsc") &&
      !isEmpty(uploadFormObj.ifsc) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "bank_address") &&
      !isEmpty(uploadFormObj.bank_address)
    ) {
      postBankInfo(uploadFormObj, dispatch);
    } else {
      setErrorMsg("Please enter the mandatory fields.");
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMsg("❌ File size must be ≤ 2MB");
      return;
    }
    onSelectValue("cancelled_cheque", selectedFile);
    setErrorMsg("");
  };

  const bankInfoForm = (
    <>
      <Row className="m-0 form-row ">
        <Row className="m-0 px-0 w-full px-0 mb-4 title-button-row">
          <h2>{!isUpdateMode ? "ADD Bank details" : "Update Bank details"}</h2>
          {bankInfo?.data !== null && (
            <CustomButton
              buttonClasses="view-switch-btn"
              onClick={() => {
                setIsCreateMode(false);
                setUploadFormObj({});
              }}
            >
              {"View"}
            </CustomButton>
          )}
        </Row>
        <Form className="my-2 modal-custom-class" onSubmit={createUpdateBankingInfo}>
          <Row className="m-0 ">
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Account Name"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.account_name}
                  onChange={(e) => onSelectValue("account_name", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Account Number"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.account_number}
                  onChange={(e) => onSelectValue("account_number", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Bank Name"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.bank_name}
                  onChange={(e) => onSelectValue("bank_name", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"IFSC"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.ifsc}
                  onChange={(e) => onSelectValue("ifsc", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Bank Address"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.bank_address}
                  onChange={(e) => onSelectValue("bank_address", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>
                  Upload Cancelled Cheque (PNG/JPG/PDF ≤ 2MB)
                  <span className="redStreSpan">{"*"}</span>
                  {(() => {
                    if (bankInfo?.data?.cancelled_cheque) {
                      return (
                        <Image
                          className="img-fluid px-0 mx-0 mt-2"
                          src={bankInfo?.data?.cancelled_cheque}
                          alt="Cancelled Cheque"
                          style={{ width: "300px" }}
                        />
                      );
                    }
                  })()}
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={handleFileChange}
                  className="custom-file-input"
                />
              </Form.Group>
            </Col>
          </Row>

          {errorMsg && <p className="error-msg">{errorMsg}</p>}
          <div className="action-buttons">
            {bankInfo?.data !== null && (
              <CustomButton
                buttonClasses="close-btn"
                onClick={() => setIsCreateMode(false)}
                disabled={requestCall?.loading}
              >
                {"Close"}
              </CustomButton>
            )}

            <CustomButton
              variant="primary"
              buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
              type="submit"
              loading={requestCall?.loading}
            >
              {!isUpdateMode ? "Add" : "update"}
            </CustomButton>
          </div>
        </Form>
      </Row>
    </>
  );

  return (
    <Container fluid className="p-0 bankInfo-container">
      {bankInfo?.loading ? (
        <Spinner />
      ) : !isEmpty(bankInfo?.data) && !isCreateMode ? (
        <Row className="bankInfo m-0">
          <Row className="heading-div ">
            <h5 className="text-uppercase p-0  m-0">{"Bank details"}</h5>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsCreateMode(true);
                setIsUpdateMode(true);
                setUploadFormObj(bankInfo?.data);
              }}
            >
              {"Edit"}
            </p>
          </Row>
          <hr />
          <Row className="m-0 p-0">
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Account Name:"}</span>
                <span className="mx-2 bold-span"> {bankInfo?.data?.account_name}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Bank Name:"}</span>
                <span className="mx-2 bold-span"> {bankInfo?.data?.bank_name}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Bank Address:"}</span>
                <span className="mx-2 bold-span"> {bankInfo?.data?.bank_address}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Account Number:"}</span>
                <span className="mx-2 bold-span"> {bankInfo?.data?.account_number}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"IFSC:"}</span>
                <span className="mx-2 bold-span"> {bankInfo?.data?.ifsc}</span>
              </p>
            </Col>
          </Row>
          <Row className="m-0 p-0">
            <h5 className="text-uppercase p-0 m-0 mt-3 small">Cancelled Cheque</h5>
            {(() => {
              if (bankInfo?.data?.cancelled_cheque) {
                return (
                  <Image
                    className="img-fluid px-0 mx-0 mt-2"
                    src={bankInfo?.data?.cancelled_cheque}
                    alt="Cancelled Cheque"
                    style={{ width: "300px" }}
                  />
                );
              } else {
                return (
                  <p className="text-danger small px-0 mt-2 m-0">
                    Please upload cancelled cheque by clicking on the "Edit" button.
                  </p>
                );
              }
            })()}
          </Row>
        </Row>
      ) : (
        bankInfoForm
      )}
    </Container>
  );
};

export default BankingAndTaxation;
